export const ROLE = {
    ADMINISTRADOR_ROOT: 1,
    ADMINISTRADOR: 2,
    MEDICO: 3,
    ENFERMERA: 5,
    SUPERVISOR: 6
}
export const NIVEL = {
    N0: 0,
    N1: 1,
    N2: 2,
    N3: 3,
    N4: 4
}